const ESignHRConfigModule = {
    namespaced: true,
    state: {
        hrEsignConfig: null,
        configLoading: true,
    },
    actions: {
        SET_HR_ESIGN_CONFIG({ state, commit }, hrEsignConfig) {
            commit('SetESignHRConfig', hrEsignConfig);
        },
    },
    mutations: {
        SetESignHRConfig: function (state, hrEsignConfig) {
            state.hrEsignConfig = hrEsignConfig;
            state.configLoading = false;
        },
    },
    getters: {
        GetESignHRConfig: function (state) {
            try {
                return state.hrEsignConfig;
            } catch (err) {
                return null;
            }
        },
        ESignHRConfigLoaded: function (state) {
            return state.hrEsignConfig != null
        },
        ESignHRConfigLoading: function (state) {
            return state.configLoading
        },
        GetSocieties: function (state) {
            return state.hrEsignConfig.society
        },
        GetContracts: function (state) {
            return state.hrEsignConfig.contract_type
        },
        GetSignatoriesOne: function (state) {
            return state.hrEsignConfig.signatories.signatory_one[0]?.email_list
        },
        GetSignatoriesTwo: function (state) {
            return state.hrEsignConfig.signatories.signatory_one[0]?.email_list
        }
    }
}
export default ESignHRConfigModule;